// extracted by mini-css-extract-plugin
module.exports = {"button-default":"RSIconButtonAnchor_button-default__sr0te"};